import { call, put, select, all, take } from 'redux-saga/effects';
import { produce } from 'immer';
import * as actions from './actions';
import axios from 'axios';
import { actions as campaignActions } from 'store/campaign';
import { actions as userMessageActions } from 'store/userMessaging';
import { POLLING_ENDPOINT_TIMER_MS, types, ProductType } from 'constants.js';
import {
  waitFor,
  flattenExpressionForRequest,
  mapExpressionFromResposne
} from 'store/helpers';
import * as eventSagas from 'store/event/sagas';
import {
  updateTotalCount
} from 'store/helpers/tableAndToolbar/actions';
import { updateRecipientQueryFilters } from './actions';
import { getParams } from 'store/helpers/helperFunctions';
const { waitForGetSupportedEventTypes, waitForGetEventMetaData } = eventSagas;

const setCampaignOccurrenceType = template => {
  template._campaignOccurrenceType = 'ON_DEMAND';
  template.schemaId = 'static_onDemand';

  return template;
};

export function* waitForGetQueryTemplates() {
  return yield waitFor(
    actions.getQueryTemplates(),
    actions.GETTING_QUERY_TEMPLATES_SUCCEEDED,
    actions.GETTING_QUERY_TEMPLATES_FAILED
  );
}

// the actual http calls
const apiRoot = `${window._env_?.REACT_APP_API_PATH}`;
const apiSchemaRoot = `${window._env_?.REACT_APP_SCHEMA_API_PATH}`;

const getTemplateApiRoot = (tenantId, businessContextId) =>
  `${apiRoot}tenants/${tenantId}/context/${businessContextId}/campaign-recipient-query`;

const getGuestInsightsApiRoot = (tenantId, businessContextId) =>
  `${apiSchemaRoot}tenants/${tenantId}/context/${businessContextId}/guest-insight`;

let isArchiveInProgress = false;

export const getTemplatesAsync = (tenantId, businessContextId, templateUuid) =>
  axios
    .get(
      `${getTemplateApiRoot(tenantId, businessContextId)}${templateUuid ? `/uuid/${templateUuid}` : ''
      }`
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

//deprecated
export const getTemplatesWithIdAsync = (tenantId, businessContextId, templateId) =>
  axios
    .get(
      `${getTemplateApiRoot(tenantId, businessContextId)}${
        templateId ? `/${templateId}` : ''
      }`
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export const getPaginatedTemplatesAsync = (
  tenantId,
  businessContextId,
  urlParams,
  bodyParams
) => {
  return axios
    .post(
      `${getTemplateApiRoot(tenantId, businessContextId)}/search?index=${
        urlParams.index
      }&pageSize=${urlParams.pageSize}`,
      bodyParams
    )
    .then(response => ({
      data: response.data,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });
};

export const getMinimalQueryTemplatesAsync = (
  tenantId,
  businessContextId,
  urlParams,
  bodyParams
) => {
  return axios
    .post(
      `${getTemplateApiRoot(tenantId, businessContextId)}/search?index=${
        urlParams.index
      }&pageSize=${urlParams.pageSize}`,
      bodyParams
    )
    .then(response => ({
      data: response.data,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });
};

export const createTemplateAsync = (tenantId, businessContextId, template) =>
  axios
    .post(`${getTemplateApiRoot(tenantId, businessContextId)}`, template)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export const updateTemplateAsync = (tenantId, businessContextId, template) =>
  axios
    .put(
      `${getTemplateApiRoot(tenantId, businessContextId)}/uuid/${template.uuid}`,
      template
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

//deprecated
export const updateTemplateWithIdAsync = (tenantId, businessContextId, template) =>
  axios
    .put(
      `${getTemplateApiRoot(tenantId, businessContextId)}/${template.id}`,
      template
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export const deleteTemplateAsync = (tenantId, businessContextId, templateUuid) =>
  axios
    .delete(`${getTemplateApiRoot(tenantId, businessContextId)}/uuid/${templateUuid}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

//deprecated
export const deleteTemplateWithIdAsync = (tenantId, businessContextId, templateId) =>
  axios
    .delete(`${getTemplateApiRoot(tenantId, businessContextId)}/${templateId}`)
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export const gettingRecipientDetailsAsync = (
  tenantId,
  businessContextId,
  query,
  urlParams
) =>
  axios
    .post(
      `${apiSchemaRoot}tenants/${tenantId}/context/${businessContextId}/event/query/onDemand/collection/${query.partialCollectionName}?index=${urlParams.index}&pageSize=${urlParams.pageSize}`,
      query
    )
    .then(response => ({
      data: response.data,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });

export const gettingGuestDetailsAsync = (
  tenantId,
  businessContextId,
  query,
  urlParams
) =>
  axios
    .post(
      `${getGuestInsightsApiRoot(tenantId, businessContextId)}/query/on-demand?index=${urlParams.index}&pageSize=${urlParams.pageSize}`,
      query
    )
    .then(response => ({
      data: response.data,
      totalRecords: parseInt(response.headers['x-ag-totalcount'])
    }))
    .catch(err => {
      throw err;
    });

export const gettingRecipientCountRequestIdAsync = (
  tenantId,
  businessContextId,
  query
) =>
  axios
    .post(
      `${getTemplateApiRoot(tenantId, businessContextId)}/requestCount`,
      query
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

export const gettingListsRecipientCountAsync = (
  tenantId,
  businessContextId,
  requestId
) =>
  axios
    .get(
      `${getTemplateApiRoot(tenantId, businessContextId)}/${requestId}/getCount`
    )
    .then(response => response.data)
    .catch(err => {
      throw err;
    });

// sagas

// selectors
const currentTenantId = store => store.user.selectedTenant.tenantId;
const currentBusinessContextId = store =>
  store.user.selectedBusinessContext.businessContextId;
const currentTemplate = store =>
  store.queryTemplate ? store.queryTemplate.current : {};
const templateList = store =>
  store.queryTemplate ? store.queryTemplate.list : [];
const paginatedTemplateList = store =>
  store.queryTemplate ? store.queryTemplate.paginatedList : [];
const productNames = store => store.events.supportedEventTypes.productNames;
const productCategories = store =>
  store.events.supportedEventTypes.productCategories;
const toolbarPageNo = store =>
  store.tableAndToolbar ? store.tableAndToolbar.pageNo : 0;
const toolbarRowsPerPage = store =>
  store.tableAndToolbar ? store.tableAndToolbar.rowsPerPage : 10;
const searchInput = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.searchInput : '';
const displayActive = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.displayActive : true;
const sortBy = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.sortBy : 'name';
const sortOrder = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.sortOrder : 'ASC';
const rowsPerPage = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.rowsPerPage : 10;
const pageNo = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.pageNo : 0;
const totalCount = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.totalCount : 0;
const filterTemplates = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.filterTemplates : [];
const filterProductNames = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.filterProductNames : [];
const filterProductCategories = store =>
  store.queryTemplate.filters ? store.queryTemplate.filters?.filterProductCategories : [];
// helper saga to prevent culling the saga tree on rejection of a parallelized task.
function* reflect(callArgs) {
  try {
    return { value: yield call(...callArgs), status: 'resolved' };
  } catch (ex) {
    return ex;
  }
}

export function* getTemplatesIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let currentList = yield select(templateList);
    if (
      action.type === actions.GET_QUERY_TEMPLATES &&
      (currentList.length === 0 || payload.force === true)
    ) {
      yield put(actions.gettingQueryTemplates());
      yield call(waitForGetSupportedEventTypes);
      currentList = yield call(getTemplatesAsync, tenantId, businessContextId);
      currentList = produce(currentList, draftList => {
        draftList = draftList.map(setCampaignOccurrenceType);
      });
    }

    yield put(actions.gettingQueryTemplatesSucceeded(currentList));
  } catch (ex) {
    yield put(actions.gettingQueryTemplatesFailed(ex));
  }
}

export function* getPaginatedTemplatesIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let currentList = yield select(paginatedTemplateList);
    yield call(waitForGetSupportedEventTypes);
    let productCategory = yield select(productCategories);
    let productName = yield select(productNames);
    if (
      action.type === actions.GET_PAGINATED_QUERY_TEMPLATES &&
      (currentList.length === 0 || payload.force === true)
    ) {
      const requestBody = {
        name: yield select(searchInput),
        sortBy: yield select(sortBy),
        sortOrder: yield select(sortOrder),
        active: yield select(displayActive),
        searchScopes: yield select(filterTemplates),
        productName: yield select(filterProductNames),
        productCategory: yield select(filterProductCategories)
      };

      let urlParams = {
        index: yield select(pageNo),
        pageSize: yield select(rowsPerPage)
      };
      let bodyParams = {
        ...getParams(requestBody, productName, productCategory)
      };
      let listCount = yield select(totalCount);
      if (
        isArchiveInProgress &&
        listCount - 1 &&
        urlParams.index >= (listCount - 1) / urlParams.pageSize
      ) {
        urlParams.index = urlParams.index - 1;
        yield put(updateRecipientQueryFilters({ pageNo: urlParams.index }));
      }
      yield put(actions.gettingPaginatedQueryTemplates());
      currentList = yield call(
        getPaginatedTemplatesAsync,
        tenantId,
        businessContextId,
        urlParams,
        bodyParams
      );
      yield put(updateRecipientQueryFilters({ totalCount: currentList.totalRecords }));
      currentList = produce(currentList.data, draftList => {
        draftList = draftList.map(setCampaignOccurrenceType);
      });
    }
    isArchiveInProgress = false;
    yield put(actions.gettingPaginatedQueryTemplatesSucceeded(currentList));
  } catch (ex) {
    isArchiveInProgress = false;
    yield put(updateRecipientQueryFilters({ totalCount: 0 }));
    yield put(actions.gettingPaginatedQueryTemplatesFailed(ex));
  }
}

export function* getMinimalQueryTemplatesIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = payload.businessContextId || (yield select(currentBusinessContextId));
    
    if (action.type === actions.GET_MINIMAL_QUERY_TEMPLATES) {
      yield put(actions.gettingMinimalQueryTemplates());
      
      let urlParams = {
        index: payload.index || 0,
        pageSize: payload.pageSize || 100
      };
      
      let bodyParams = {
        active: payload.active !== undefined ? payload.active : true,
        ...(payload.productCategory && { productCategory: payload.productCategory }),
        ...(payload.productName && { productName: payload.productName }),
        ...(payload.eventTypeCategory && { eventTypeCategory: payload.eventTypeCategory }),
        ...(payload.name && { name: payload.name })
      };
      
      let currentList = yield call(
        getMinimalQueryTemplatesAsync,
        tenantId,
        businessContextId,
        urlParams,
        bodyParams
      );
      
      yield put(actions.gettingMinimalQueryTemplatesSucceeded({
        data: currentList.data,
        totalRecords: currentList.totalRecords
      }));
    }
  } catch (ex) {
    yield put(actions.gettingMinimalQueryTemplatesFailed(ex));
  }
}

export function* getTemplateIfNeeded(action) {
  const { payload = {} } = action;
  try {
    yield put(actions.gettingQueryTemplate());
    let tenantId = yield select(currentTenantId);
    let businessContextId = payload.businessContextId || (yield select(currentBusinessContextId));
    let template = yield select(currentTemplate);
    let templateUuid = payload.templateId || payload.templateUuid;

    let yieldAlls = {
      supportedEventTypes: yield call(waitForGetSupportedEventTypes)
    };

    if (template.uuid !== templateUuid || payload.force === true) {
      template = yield call(
        getTemplatesAsync,
        tenantId,
        businessContextId,
        templateUuid
      );
    }

    template = produce(template, draftTemplate => {
      draftTemplate = setCampaignOccurrenceType(draftTemplate);
    });

    let eventMetaData;
    let eventFields = [];
    if (
      template.schemaIdentifier &&
      template._campaignOccurrenceType &&
      template.productName
    ) {
      yieldAlls.eventMetaData = yield call(waitForGetEventMetaData, {
        campaignOccurrenceType: template._campaignOccurrenceType,
        schemaIdentifier: template.schemaIdentifier,
        productName: template.productName,
        workflow: 'campaign',
        productType: template.productType
      });
      ({ eventMetaData: { eventMetaData } = {} } = yield all(yieldAlls));
      eventMetaData.map(data =>
        eventFields.push(...data.schemaConditionAttributes)
      );
    }

    if (
      template.uuid ||
      (template.hasOwnProperty('_hasSetTemplate') && !template._hasSetTemplate)
    ) {
      template = produce(template, draftTemplate => {
        draftTemplate.conditionExpression = mapExpressionFromResposne(
          draftTemplate?.conditionExpression || {},
          eventFields
        );
        if (draftTemplate.hasOwnProperty('_hasSetTemplate')) {
          draftTemplate._hasSetTemplate = true;
        }
        draftTemplate.hasMovedToNextStep = true;
      });
    }

    yield put(
      actions.gettingQueryTemplateSucceeded({
        template,
        eventMetaData
      })
    );
  } catch (ex) {
    yield put(actions.gettingQueryTemplateFailed(ex));
  }
}

export function* createTemplateFromCurrent() {
  try {
    yield put(actions.creatingQueryTemplate());
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let template = yield select(currentTemplate);
    let conditionExpression = template.conditionExpression;
    let metaData = template.eventMetaData;

    template = produce(template, thisTemplate => {
      thisTemplate.conditionExpression = flattenExpressionForRequest(
        thisTemplate.conditionExpression
      );
    });
    if (!template.uuid) {
      template = yield call(
        createTemplateAsync,
        tenantId,
        businessContextId,
        template
      );
    }
    template = {
      ...template,
      conditionExpression: conditionExpression,
      eventMetaData: metaData,
      hasMovedToNextStep: true,
      _campaignOccurrenceType: 'ON_DEMAND',
      campaignOccurrenceType: 'ON_DEMAND',
      schemaId: 'static_onDemand'
    };
    yield put(actions.creatingQueryTemplateSucceeded(template));
  } catch (ex) {
    yield put(actions.creatingQueryTemplateFailed(ex));
  }
}

export function* updateTemplateFromCurrent() {
  try {
    yield put(actions.updatingQueryTemplate());
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let template = yield select(currentTemplate);
    let conditionExpression = template.conditionExpression;
    let metaData = template.eventMetaData;

    template = produce(template, thisTemplate => {
      thisTemplate.conditionExpression = flattenExpressionForRequest(
        thisTemplate.conditionExpression
      );
    });

    if (template.uuid) {
      template = yield call(
        updateTemplateAsync,
        tenantId,
        businessContextId,
        template
      );
    }
    template = {
      ...template,
      conditionExpression: conditionExpression,
      eventMetaData: metaData,
      hasMovedToNextStep: true,
      _campaignOccurrenceType: 'ON_DEMAND',
      campaignOccurrenceType: 'ON_DEMAND',
      schemaId: 'static_onDemand'
    };

    yield put(actions.updatingQueryTemplateSucceeded(template));
  } catch (ex) {
    yield put(actions.updatingQueryTemplateFailed(ex));
  }
}

export function* warnAndArchive(action) {
  yield put(
    campaignActions.getAssociatedCampaignsFor({
      uuid: action.payload.uuid,
      typeOf: types.QUERY_TEMPLATE
    })
  );
  yield take(actions.GETTING_ASSOCIATED_CAMPAIGNS_FOR_QUERY_TEMPLATE_SUCCEEDED);
  let templates = yield select(paginatedTemplateList);
  let templateToWarnAbout = templates.find(
    template => template.uuid === action.payload.uuid
  );
  action.payload.message.props = {
    ...action.payload.message.props,
    template: templateToWarnAbout,
    type: 'query'
  };
  yield put(userMessageActions.setMessage(action.payload.message));
}

export function* deleteTemplatesByIdList(action) {
  const { payload } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let templateUuids = payload.templateUuids;
    let templates = yield select(paginatedTemplateList);

    let deletedTemplateStatuses = [];
    if (templateUuids.length > 0) {
      yield put(actions.deletingQueryTemplates());
      // all() prallelizes delete operations and waits until they all finish.
      // if the delete template API method can be made to return the deleted id this could be set to a variable and report partial success which would make for better failure handling.
      if (payload.hardDelete) {
        deletedTemplateStatuses = yield all(
          templateUuids
            .map(templateUuid => [
              deleteTemplateAsync,
              tenantId,
              businessContextId,
              templateUuid
            ])
            .map(reflect)
        );
      } else {
        deletedTemplateStatuses = yield all(
          templateUuids
            .map(templateUuid => {
              const template = templates.find(t => t.uuid === templateUuid);
              return [
                updateTemplateAsync,
                tenantId,
                businessContextId,
                {
                  ...template,
                  active: !payload.activeStatus
                }
              ];
            })
            .map(reflect)
        );
      }
    }
    if (
      deletedTemplateStatuses.filter(status => status.status === 'resolved')
        .length === templateUuids.length
    ) {
      isArchiveInProgress = true;
      yield all([
        put(
          actions.deletingQueryTemplatesSucceeded(
            templateUuids,
            payload.hardDelete
          )
        ),
        put(actions.getPaginatedQueryTemplates({ force: true }))
      ]);
    } else {
      yield put(
        actions.deletingQueryTemplatesFailed({
          message: 'Not all requested templates could be deleted.',
          deletedTemplateStatuses
        })
      );
    }
  } catch (ex) {
    isArchiveInProgress = false;
    yield put(
      actions.deletingQueryTemplatesFailed({
        ...ex,
        hardDelete: payload.hardDelete
      })
    );
  }
}

export function* getRecipientDetailsIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let query = { ...JSON.parse(JSON.stringify(payload)), active: true };
    let urlParams = {
      index: yield select(toolbarPageNo),
      pageSize: yield select(toolbarRowsPerPage)
    };
    query.conditionExpression = flattenExpressionForRequest(
      query.conditionExpression
    );
    let details = {};
    if (payload.productType === ProductType.GUEST_INSIGHTS) {
      details = yield call(
        gettingGuestDetailsAsync,
        tenantId,
        businessContextId,
        query,
        urlParams
      )
    } else {
      details = yield call(
        gettingRecipientDetailsAsync,
        tenantId,
        businessContextId,
        query,
        urlParams
      );
    }
    yield put(updateTotalCount(details.totalRecords));
    yield put(actions.gettingRecipientDetailsSucceeded(details));
  } catch (ex) {
    yield put(actions.gettingRecipientDetailsFailed(ex));
  }
}

export function* getRecipientCountRequestIdIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let query = { ...JSON.parse(JSON.stringify(payload)), active: true };

    query.conditionExpression = flattenExpressionForRequest(
      query.conditionExpression
    );
    let requestId = yield call(
      gettingRecipientCountRequestIdAsync,
      tenantId,
      businessContextId,
      query
    );
    yield put(actions.gettingRecipientCountRequestIdSucceeded({ requestId }));
  } catch (ex) {
    yield put(actions.gettingRecipientCountRequestIdFailed(ex));
  }
}

export function* getListsRecipientCountIfNeeded(action) {
  const { payload = {} } = action;
  try {
    let tenantId = yield select(currentTenantId);
    let businessContextId = yield select(currentBusinessContextId);
    let response = yield call(
      gettingListsRecipientCountAsync,
      tenantId,
      businessContextId,
      payload.requestId
    );

    if (response.errorMessage) {
      yield put(actions.gettingListsRecipientCountFailed());
    } else if (response.count) {
      yield put(
        actions.gettingListsRecipientCountSucceeded({ count: response.count })
      );
    } else {
      yield put(actions.startPolling(action.payload));
    }
  } catch (ex) {
    yield put(actions.gettingListsRecipientCountFailed(ex));
  }
}

let timer;
export function* startPollingIfNeeded() {
  if (timer) {
    clearTimeout(timer);
  }
  yield call(
    () =>
      new Promise(resolve => {
        timer = setTimeout(resolve, POLLING_ENDPOINT_TIMER_MS);
      })
  );

  yield put(actions.endPolling());
}
